import { render, staticRenderFns } from "./studentManageMent.vue?vue&type=template&id=6f9ab723&scoped=true&"
import script from "./studentManageMent.vue?vue&type=script&lang=js&"
export * from "./studentManageMent.vue?vue&type=script&lang=js&"
import style0 from "./studentManageMent.vue?vue&type=style&index=0&id=6f9ab723&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9ab723",
  null
  
)

export default component.exports